// Types for time range filtering
export type TimeRange = 'current' | 'lastMonth' | '6months' | '1year' | 'all' | 'custom';

export interface DateRange {
  startDate?: Date;
  endDate?: Date;
}

export interface TimeRangeOption {
  value: TimeRange;
  label: string;
}

export const timeRangeOptions: TimeRangeOption[] = [
  { value: 'all', label: 'Toutes les données' },
  { value: 'current', label: 'En cours' },
  { value: 'lastMonth', label: 'Mois dernier' },
  { value: '6months', label: '6 mois' },
  { value: '1year', label: '1 an' },
  { value: 'custom', label: 'Personnaliser' },
];

// Helper function to calculate date ranges
export const calculateDateRange = (range: TimeRange, customRange?: DateRange): DateRange => {
  const now = new Date();

  switch (range) {
    case 'all':
      // No date filtering - return undefined dates to show all data
      return { startDate: undefined, endDate: undefined };
    case 'current':
      return {
        startDate: new Date(now.getFullYear(), now.getMonth(), 1),
        endDate: now
      };
    case 'lastMonth':
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);
      return {
        startDate: lastMonth,
        endDate: lastMonthEnd
      };
    case '6months':
      return {
        startDate: new Date(now.getFullYear(), now.getMonth() - 6, 1),
        endDate: now
      };
    case '1year':
      return {
        startDate: new Date(now.getFullYear() - 1, now.getMonth(), 1),
        endDate: now
      };
    case 'custom':
      return customRange || { startDate: undefined, endDate: undefined };
    default:
      return { startDate: undefined, endDate: undefined };
  }
};

// Helper function to format dates for API calls
export const formatDateForAPI = (date?: Date): string | undefined => {
  if (!date) return undefined;
  return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
};
